import { confirmation, notify } from '@/components';
import { useUnlistTaskTemplateMutation} from '@/redux';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export function useUnlistTaskTemplate(goBack: boolean) {
  const [unlist] = useUnlistTaskTemplateMutation();
  const push = useNavigate();

  const performUnlist = useCallback(
    (id: string) =>
      unlist({ id }).then(() =>
        notify.success.t('taskTemplates.details.unlisted'),
      ),
    [unlist],
  );

  return useCallback(
    (id: string) =>
      confirmation.delete({ key: 'taskTemplates.entityName' }, () => {
        performUnlist(id);
        if (goBack) push(-1);
      }),
    [goBack, performUnlist, push],
  );
}

export function useBoundUnlistTaskTemplate(id: string | undefined) {
  const unlist = useUnlistTaskTemplate(true);
  return useCallback(() => (id ? unlist(id) : Promise.reject()), [id, unlist]);
}